export var HEAVY = [
    '┏━┳┓',
    '┃ ┃┃',
    '┣━╋┫',
    '┃ ┃┃',
    '┗━┻┛'
].join('');
export var DEFAULT = [
    '┏━┳┓',
    '┃ ┃┃',
    '┡━╇┩',
    '│ ││',
    '└─┴┘'
].join('');
export var THIN = [
    '┌─┬┐',
    '│ ││',
    '├─┼┤',
    '│ ││',
    '└─┴┘'
].join('');
export var ROUNDED = [
    '╭─┬╮',
    '│ ││',
    '├─┼┤',
    '│ ││',
    '╰─┴╯'
].join('');
export var SEMI_ROUNDED = [
    '┏━┳┓',
    '┃ ┃┃',
    '┡━╇┩',
    '│ ││',
    '╰─┴╯'
].join('');
export var ASCII = [
    '+-++',
    '| ||',
    '+-++',
    '| ||',
    '+-++'
].join('');
